module.exports = __webpack_public_path__ + "img/cal-stacked.d0077423.png";